<app-landing-header *ngIf="!(authService.isLoggedIn$ | async)"></app-landing-header>
<app-header *ngIf="authService.isLoggedIn$ | async"></app-header>
<div class="main-container">
  <div class="contacts">
    <div class="contact">
      <div class="contact__row">
        <div class="contact__col">
          <div class="contact__info">
            <img src="./assets/images/workflow-round.png" alt="" />
            <div class="contact__info-name">
              <div class="name">WorkFlow</div>
            </div>
          </div>
        </div>
      </div>

      <div class="contact__card">
        <div class="contact__col">
          <div class="contact__card-title">{{ 'contacts.title' | translate }}</div>
          <ul>
            <li>
              <span class="icon-Email"></span> workflow&#64;theraven.tech
              <span class="icon-hover icon-Copy" (click)="onCopyText('workflow@theraven.tech')"></span>
            </li>
            <li><span class="icon-Location"></span> {{ 'contacts.address' | translate }}</li>
          </ul>
        </div>
        <div class="contact__col">
          <a class="qrcode" href="https://t.me/workflow_space" target="_blank"
            ><img src="./assets/images/qrcode.webp" alt="WorkFlow" loading="lazy" width="108" height="118"
          /></a>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
